module.exports = __webpack_public_path__ + "img/crusher.89f3711e.png";